module.exports = __webpack_public_path__ + "img/2.db7956fd.jpg";